import { useTranslation } from 'react-i18next';
import { Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';

import { ReactComponent as Icon } from '../../assets/icons/businessStation.svg';

export default function BusinessStationIcon({ tooltipEnabled }) {
  const { t } = useTranslation('accessCategories');

  if (tooltipEnabled) {
    return (
      <Tooltip title={t('BUSINESS')} placement="bottom-start">
        <Icon className="MuiSvgIcon-root" alt="category-image" />
      </Tooltip>
    );
  }

  return <Icon className="MuiSvgIcon-root" alt="category-image" />;
}

BusinessStationIcon.defaultProps = {
  tooltipEnabled: false,
};

BusinessStationIcon.propTypes = {
  tooltipEnabled: PropTypes.bool,
};
